<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <!--<NavBar></NavBar>-->
        <div class="deviceTestDIV container "> 
            <div class="wrapper mt-2">
                <div class="main-title">
                    DEVICE TEST
                </div>
            </div>
            
            <div class="accordion" id="TestAccordion">
                <!--喇叭測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headAudioOutput" :style="AudioOutputStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colAudioOutput" aria-expanded="false" aria-controls="colAudioOutput" :style="AudioOutputStyle">
                            喇叭測試
                        </div>
                    </div>
                    <div id="colAudioOutput" class="collapse deviceTestContent show" aria-labelledby="headAudioOutput" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <AudioOutputTest></AudioOutputTest>  
                                <div class="d-flex deviceBtnGroup ">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getAUDIOOutputOK(true)" >PASS</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getAUDIOOutputOK(false)" >FAIL</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--麥克風測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headAudioInput" :style="AudioInputStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colAudioInput" aria-expanded="false" aria-controls="colAudioInput" :style="AudioInputStyle">
                            麥克風測試
                        </div>
                    </div>
                    <div id="colAudioInput" class="collapse deviceTestContent" aria-labelledby="headAudioInput" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <AudioInputTest></AudioInputTest> 
                                <div class="d-flex deviceBtnGroup ">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getAudioInputOK(true)" >PASS</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getAudioInputOK(false)" >FAIL</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>

                <!--攝影機測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headVideo" :style="VideoStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colVideo" aria-expanded="false" aria-controls="colVideo" :style="VideoStyle">
                            視訊測試
                        </div>
                    </div>
                    <div id="colVideo" class="collapse deviceTestContent" aria-labelledby="headVideo" data-parent="#TestAccordion">
                        <div class="deviceTestBody ">
                            <div class="d-flex justify-content-between flex-wrap py-1">
                                <videoTEST></videoTEST>
                                <div class="d-flex deviceBtnGroup ">
                                    <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getVideoOK(true)" >PASS</button>
                                    <button type="button" class="btn FAILBTN deviceTestBTN" v-on:click="getVideoOK(false)" >FAIL</button>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--瀏覽器測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headOne" v-bind:style="BrowserStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#coldeviceTest" aria-expanded="false" aria-controls="coldeviceTest" v-bind:style="BrowserStyle" v-on:click="getChromeVersion()">
                            瀏覽器測試
                        </div>
                    </div>
                    <div id="coldeviceTest" class="collapse deviceTestContent" aria-labelledby="headOne" data-parent="#TestAccordion">
                        <div class=" deviceTestBody d-flex justify-content-between">
                            <!--<span>瀏覽器版本需更新至最新版.</span> -->
                            <span>Google Chrome版本需為 <code>{{ChromeVersion}}</code> 以上.</span> 
                            <!--<div>
                                <button type="button" class="btn OKBTN deviceTestBTN" v-on:click="getChromeVersion" >OK</button>
                            </div>-->
                        </div>
                    </div>
                </div>

                <!--網速測試-->
                <div class="deviceTestCard">
                    <div class="deviceTestHeader" id="headNetSpeed" v-bind:style="NetStyle">
                        <div class="collapsed text-left" data-toggle="collapse" data-target="#colNetSpeed" aria-expanded="false" aria-controls="colNetSpeed" v-bind:style="NetStyle">
                            網速測試
                        </div>
                    </div>
                    <div id="colNetSpeed" class="collapse deviceTestContent" aria-labelledby="headNetSpeed" data-parent="#TestAccordion">
                        <div class="deviceTestBody">
                            <netTest></netTest>
                            <!--<button type="button" class="btn OKBTN deviceTestBTN"  v-on:click="getNetOK">OK</button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

import AudioOutputTest from '@/components/DeviceTestPages/AudioOutputTest'
import videoTEST from '@/components/DeviceTestPages/videoTest'
import AudioInputTest from '@/components/DeviceTestPages/AudioInputTest'
import netTest from '@/components/DeviceTestPages/netTest'

export default {
    name: 'SimpleDeviceTest',
    components:{
        NavBar,videoTEST,AudioInputTest,netTest,AudioOutputTest
    },
    data () {
        return {
            // Token:'',
            UserId:'',
            showLoading:false,
            ChromeVersion:'100.0',
            NowBrowserVersion:'',
            browser:'',
            version:'',
            OS:'',
            IP:'',
            Model:'',
            BrowserStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            AudioOutputStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            AudioInputStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            NetStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            VideoStyle:{backgroundColor: "#FCF9F0",color:"#3D708F"},
            OKStyle:{backgroundColor: "#99C3D9",color:"#3D708F"},
            NotOKStyle:{backgroundColor: "#E47451",color:"white"},
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || 'DeviceTest 設備檢測';
            }
        },
    },
    methods:{        
        getChromeVersion: function () { 
            // this.browserVersionType()
            this.BrowserStyle = this.OKStyle;
            /*var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            this.NowBrowserVersion=raw[2];
            if (parseFloat(raw[2], 10) >= parseFloat(this.ChromeVersion)){// Version OK
                this.BrowserStyle = this.OKStyle;
            }else{// Version NOT OK
                this.BrowserStyle = this.NotOKStyle;
                alert("Google Chrome目前版本為"+parseFloat(raw[2], 10)+"，請更新。");
            }*/
        },
        getAUDIOOutputOK(Status){
            if(!Status){
                this.AudioOutputStyle = this.NotOKStyle;
            }else if(this.GLOBAL.AUDIOOutputOK){
                this.AudioOutputStyle = this.OKStyle;
                var output = document.querySelector('#colAudioOutput').classList.remove('show');
                var input = document.querySelector('#colAudioInput').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert("找不到喇叭設備");
                }
                this.AudioOutputStyle = this.NotOKStyle;
            }
        },
        getAudioInputOK(Status){
            if(!Status){
                this.AudioInputStyle = this.NotOKStyle;
            }else if(this.GLOBAL.AUDIOInputOK){
                this.AudioInputStyle = this.OKStyle;
                var output = document.querySelector('#colAudioInput').classList.remove('show');
                var input = document.querySelector('#colVideo').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert("找不到麥克風設備");
                }
                this.AudioInputStyle = this.NotOKStyle;
            }
        },      
        getVideoOK(Status){
            if(!Status){
                this.VideoStyle = this.NotOKStyle;
            }else if(this.GLOBAL.VideoOK){
                this.VideoStyle = this.OKStyle;
                var output = document.querySelector('#colVideo').classList.remove('show');
                var input = document.querySelector('#deviceTest').classList.add('show');
            }else{
                if(Status){//not OK but click OK BTN 
                    alert("找不到視訊設備");
                }
                this.VideoStyle = this.NotOKStyle;
            }
        },  
        getNetOK(){
            if(this.GLOBAL.NetOK){
                this.NetStyle = this.OKStyle;
            }else{
                this.NetStyle = this.NotOKStyle;
            }
        },
        OSType(){
            var OSName = "Unknown";
            if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
            if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1) OSName="Windows 8.1";
            if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
            if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
            if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
            if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
            if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
            if (window.navigator.userAgent.indexOf("Mac")            != -1) OSName="Mac/iOS";
            if (window.navigator.userAgent.indexOf("X11")            != -1) OSName="UNIX";
            if (window.navigator.userAgent.indexOf("Linux")          != -1) OSName="Linux";
            if (window.navigator.userAgent.indexOf("Android")        != -1) OSName="Android";
            if (window.navigator.userAgent.indexOf("MeeGo")          != -1) OSName="MeeGo";
            return OSName;
        },
    },    
    created(){
        this.OS =this.OSType();
        this.$root.$refs.SimpleDeviceTest = this;
        this.$root.$refs.OS = this.OS
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/SimpleDeviceTest.vue